
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function EquipmentPackIndex() {
  return (
    <NonFSIndex
      data_type="equipment_pack"
      // save_all
    />
  );
}
